// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    border: 8px solid #f3f3f3;
    /* Light grey */
    border-top: 8px solid #3498db;
    /* Blue */
    border-radius: 50%;
    width: 50px;
    /* Size of the spinner */
    height: 50px;
    /* Size of the spinner */
    animation: spin 1s linear infinite;
    /* Spin animation */
    margin: 20px auto;
    /* Centering the spinner */
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.product-container{
    margin: 100px 20px;
    display: flex;
    justify-content: left;
    
}

.product-image{
    width:500px;
    height:500px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 50px;
    margin-bottom: 0px;
    position:relative;
}

.product-image img{
    width:400px;
    height:400px;
    transition: transform 0.3s ease;
}
.product-image img:hover {
    /* transform: scale(5);
     */
    /* Scale the image on hover */
    cursor: zoom-in;
}

.product-details-container{
    margin:20px;
    width:700px;
    
}
.product-details-container h3{
    font-family: 'Philosopher',serif;
    font-weight: 700;
    text-align: left;
}

.product-details-container p{
    font-family: 'Poppins',sans-serif;
    font-weight: 500;
    font-size: 13px;
    /* color:#111; */
    text-align: left;
    letter-spacing: 1px;
   
}

.write-review{
    display: flex;
    justify-content: left;
    margin: 10px;
    padding: 5px;
    border-top:rgba(0,0,0,0.1);
    border-bottom: rgba(0, 0, 0, 0.1);
    border-style:solid;
    
    border-right: none;
    border-left: none;
}

.price-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    
}

.price-container p{
    margin-right: 20px;
    /* color:#444; */
}

.price-container span{
    position: relative;
    top:-4px;
    margin-right: 5px;
}

.additional-details{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 250px;
    margin-bottom:-50px;

}

.additional-details h5{
    font-family: 'Philosopher',serif;
    font-weight: 700;
    font-size: 18px;
}

.additional-details p{
   text-align: left;
}

.product-container .cart-container{
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-content: left;
    margin-top:30px;
    padding-top: 0px;
}

.cart-quantity-control{
    display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
    padding:0px;
    border: rgba(0, 0, 0, 0.3);
    border-style: solid;
    border-width: 1px;
    width:120px;
    height:40px;
    border-radius:5px;
    
}

.cart-quantity-control button{
    text-align: left;
    margin-left:0px;
    font-size: 20px;
    color:#999999;
    border: none;
}

.cart-quantity-control p{
    
    color:#666666;
    width:40px;
    text-align: center;
}

.cart-buttons{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.cart-button{
    background-color: #ffa406;
    width:180px;
    height:50px;
    border-radius: 25px;
    color:#ffffff;
    font-family: 'Philosopher',serif;
    margin-left: 0px;
    margin-top: 20px;
    border:none;
    font-size:18px ;
    position: relative;
        overflow: hidden;
        cursor: pointer;
    
        z-index: 1
}



.taxes-info{
    margin-top: -20px;
}

.share-button{
    margin-right: 5px;
}



.cart-button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #77b500;
    z-index: -1;
    border-radius: 10rem;
    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.cart-button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}

.buy-button{
    width:180px;
    height:50px;
    border-radius: 25px;
    background-color: #77b500;
    color:#ffffff;
    font-family: 'Poppins',sans-serif;
    font-size: 20px;
    margin-top: 20px;
    margin-left: 20px;
    margin-bottom: 0px;
    border:none;
    position: relative;
        overflow: hidden;
        cursor: pointer;
    
        z-index:0;

}


.buy-button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #ffa406;
    z-index: -1;
    border-radius: 10rem;
    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.buy-button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}


.navigation-buttons{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 50px;
}

.navigation-buttons button{
    width:30px;
    height:30px;
    border-radius: 25px;
    border:rgba(0, 0, 0, 0.3);
    border-style: solid;
    border-width: 1px;
    margin-left: 10px;
}

.description-reviews-container{
    width: 90vw;
    max-height:max(200px,120%);
    border:rgba(0, 0, 0, 0.1);
    border-style: solid;
    border-width: 1px;
    border-radius: 10px;
    margin-left: 5vw;
}

.description-review-options{
    display: flex;
    flex-direction: row;
    margin: 0px 20px;
    border-bottom: rgba(0, 0, 0, 0.1);
        border-style: solid;
        border-width: 1px;
    border-left: none;
    border-right: none;
    border-top: none;
}

.description-review-options h3{
    font-family: 'Philosopher',serif;
    font-weight: 700;
    margin-right: 20px;
    cursor: pointer;
    
}

.description-active{
       border-bottom: rgba(0, 0, 0, 0.9);
        border-style: solid;
        border-width: 3px;
        border-left: none;
        border-right: none;
        border-top: none;
        cursor: pointer;
        

}

.review-active{
        border-bottom: rgba(0, 0, 0, 0.9);
        border-style: solid;
        border-width: 3px;
        border-left: none;
        border-right: none;
        border-top: none;
        cursor: pointer;
}
.specification-active {
    border-bottom: rgba(0, 0, 0, 0.9);
    border-style: solid;
    border-width: 3px;
    border-left: none;
    border-right: none;
    border-top: none;
    cursor: pointer;


}
.description-content{
    margin: 0px 20px;
}

.description-content p{
    font-family: 'Poppins',sans-serif;
    font-size: 13px;
    /* color:#666666; */
    text-align: left;
    letter-spacing: 1px;
}

.reviews-content{
    display: flex;
    flex-direction: row;
    margin-top:10px;
}

.reviews-content p{
    margin-left: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 13px;
    text-align: left;
    letter-spacing: 1px;

}

.reviews-card{
    width:400px;
    height:150px;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    justify-items: left;
}

.review-image{
    width:30%;
}

.review-image img{
    width:60px;
    height:60px;
    border-radius: 30px;
    margin: 0px;

}

.review-stars{
    margin-left: 0px;
    
}
.review-stars {
    outline: none;
}

.review-stars:focus {
    outline: none;
}

.review-stars {
    border: none !important;
    box-shadow: none !important;
}

.review-stars:hover,
.review-stars:active {
    border: none;
    box-shadow: none;
}


.review-content{
    width:70%;
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items:flex-start;
    

    
}
.review-content p{
    font-size: 12px;
    font-family: 'Poppins',sans-serif;
    text-align:left;
    line-height: 14px;
    margin-bottom: 5px;
    letter-spacing: 1px;
    margin-left: 0px;
    width:100%;
    display: flex;
    justify-content: left;
}

.mobile-navigation-buttons{
    display: none;
}


@media screen and (max-width:768px){
    .product-container {
            margin: 110px 20px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-top:100px;
    
        }
        .product-image {
            width: 90%;
            height: auto;
    
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 0px;
            ;
        }
        .product-image img{
            width:90%;
            height:auto;
        }
        .mobile-navigation-buttons {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin-top: 80px;
        }
    
        .mobile-navigation-buttons button {
            width: 30px;
            height: 30px;
            border-radius: 25px;
            border: rgba(0, 0, 0, 0.3);
            border-style: solid;
            border-width: 1px;
            margin-left: 10px;
        }
        .navigation-buttons{
            display: none;
        }
        .product-details-container {
            margin: 20px;
            width: 90%;
    
        }
    
}


`, "",{"version":3,"sources":["webpack://./src/Styles/ShopProducts.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,wBAAwB;IACxB,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;;AAEzB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;AACA;IACI;MACE;IACF,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;;AAEf;AACA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,kBAAkB;;IAElB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;QACT,mBAAmB;QACnB,mBAAmB;QACnB,6BAA6B;IACjC,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;QACd,gBAAgB;QAChB,eAAe;;QAEf;AACR;;;;AAIA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;;;AAIA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;QACd,gBAAgB;QAChB,eAAe;;QAEf,SAAS;;AAEjB;;;AAGA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;;;AAIA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;QAC7B,mBAAmB;QACnB,iBAAiB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;OACO,iCAAiC;QAChC,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;;;AAGvB;;AAEA;QACQ,iCAAiC;QACjC,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;AACvB;AACA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;;;AAGnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,WAAW;;AAEf;;AAEA;IACI,gBAAgB;;AAEpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;;;;AAI1B;AACA;IACI,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI;YACQ,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,sBAAsB;YACtB,mBAAmB;YACnB,gBAAgB;;QAEpB;QACA;YACI,UAAU;YACV,YAAY;;YAEZ,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,eAAe;;QAEnB;QACA;YACI,SAAS;YACT,WAAW;QACf;QACA;YACI,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,mBAAmB;YACnB,0BAA0B;YAC1B,mBAAmB;YACnB,iBAAiB;YACjB,iBAAiB;QACrB;QACA;YACI,aAAa;QACjB;QACA;YACI,YAAY;YACZ,UAAU;;QAEd;;AAER","sourcesContent":[".loader {\n    border: 8px solid #f3f3f3;\n    /* Light grey */\n    border-top: 8px solid #3498db;\n    /* Blue */\n    border-radius: 50%;\n    width: 50px;\n    /* Size of the spinner */\n    height: 50px;\n    /* Size of the spinner */\n    animation: spin 1s linear infinite;\n    /* Spin animation */\n    margin: 20px auto;\n    /* Centering the spinner */\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.product-container{\n    margin: 100px 20px;\n    display: flex;\n    justify-content: left;\n    \n}\n\n.product-image{\n    width:500px;\n    height:500px;\n    \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 50px;\n    margin-bottom: 0px;\n    position:relative;\n}\n\n.product-image img{\n    width:400px;\n    height:400px;\n    transition: transform 0.3s ease;\n}\n.product-image img:hover {\n    /* transform: scale(5);\n     */\n    /* Scale the image on hover */\n    cursor: zoom-in;\n}\n\n.product-details-container{\n    margin:20px;\n    width:700px;\n    \n}\n.product-details-container h3{\n    font-family: 'Philosopher',serif;\n    font-weight: 700;\n    text-align: left;\n}\n\n.product-details-container p{\n    font-family: 'Poppins',sans-serif;\n    font-weight: 500;\n    font-size: 13px;\n    /* color:#111; */\n    text-align: left;\n    letter-spacing: 1px;\n   \n}\n\n.write-review{\n    display: flex;\n    justify-content: left;\n    margin: 10px;\n    padding: 5px;\n    border-top:rgba(0,0,0,0.1);\n    border-bottom: rgba(0, 0, 0, 0.1);\n    border-style:solid;\n    \n    border-right: none;\n    border-left: none;\n}\n\n.price-container{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    \n}\n\n.price-container p{\n    margin-right: 20px;\n    /* color:#444; */\n}\n\n.price-container span{\n    position: relative;\n    top:-4px;\n    margin-right: 5px;\n}\n\n.additional-details{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 250px;\n    margin-bottom:-50px;\n\n}\n\n.additional-details h5{\n    font-family: 'Philosopher',serif;\n    font-weight: 700;\n    font-size: 18px;\n}\n\n.additional-details p{\n   text-align: left;\n}\n\n.product-container .cart-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: left;\n    align-content: left;\n    margin-top:30px;\n    padding-top: 0px;\n}\n\n.cart-quantity-control{\n    display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-evenly;\n    padding:0px;\n    border: rgba(0, 0, 0, 0.3);\n    border-style: solid;\n    border-width: 1px;\n    width:120px;\n    height:40px;\n    border-radius:5px;\n    \n}\n\n.cart-quantity-control button{\n    text-align: left;\n    margin-left:0px;\n    font-size: 20px;\n    color:#999999;\n    border: none;\n}\n\n.cart-quantity-control p{\n    \n    color:#666666;\n    width:40px;\n    text-align: center;\n}\n\n.cart-buttons{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n.cart-button{\n    background-color: #ffa406;\n    width:180px;\n    height:50px;\n    border-radius: 25px;\n    color:#ffffff;\n    font-family: 'Philosopher',serif;\n    margin-left: 0px;\n    margin-top: 20px;\n    border:none;\n    font-size:18px ;\n    position: relative;\n        overflow: hidden;\n        cursor: pointer;\n    \n        z-index: 1\n}\n\n\n\n.taxes-info{\n    margin-top: -20px;\n}\n\n.share-button{\n    margin-right: 5px;\n}\n\n\n\n.cart-button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #77b500;\n    z-index: -1;\n    border-radius: 10rem;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.cart-button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n.buy-button{\n    width:180px;\n    height:50px;\n    border-radius: 25px;\n    background-color: #77b500;\n    color:#ffffff;\n    font-family: 'Poppins',sans-serif;\n    font-size: 20px;\n    margin-top: 20px;\n    margin-left: 20px;\n    margin-bottom: 0px;\n    border:none;\n    position: relative;\n        overflow: hidden;\n        cursor: pointer;\n    \n        z-index:0;\n\n}\n\n\n.buy-button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #ffa406;\n    z-index: -1;\n    border-radius: 10rem;\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.buy-button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n\n\n.navigation-buttons{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    margin-top: 50px;\n}\n\n.navigation-buttons button{\n    width:30px;\n    height:30px;\n    border-radius: 25px;\n    border:rgba(0, 0, 0, 0.3);\n    border-style: solid;\n    border-width: 1px;\n    margin-left: 10px;\n}\n\n.description-reviews-container{\n    width: 90vw;\n    max-height:max(200px,120%);\n    border:rgba(0, 0, 0, 0.1);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 10px;\n    margin-left: 5vw;\n}\n\n.description-review-options{\n    display: flex;\n    flex-direction: row;\n    margin: 0px 20px;\n    border-bottom: rgba(0, 0, 0, 0.1);\n        border-style: solid;\n        border-width: 1px;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n}\n\n.description-review-options h3{\n    font-family: 'Philosopher',serif;\n    font-weight: 700;\n    margin-right: 20px;\n    cursor: pointer;\n    \n}\n\n.description-active{\n       border-bottom: rgba(0, 0, 0, 0.9);\n        border-style: solid;\n        border-width: 3px;\n        border-left: none;\n        border-right: none;\n        border-top: none;\n        cursor: pointer;\n        \n\n}\n\n.review-active{\n        border-bottom: rgba(0, 0, 0, 0.9);\n        border-style: solid;\n        border-width: 3px;\n        border-left: none;\n        border-right: none;\n        border-top: none;\n        cursor: pointer;\n}\n.specification-active {\n    border-bottom: rgba(0, 0, 0, 0.9);\n    border-style: solid;\n    border-width: 3px;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    cursor: pointer;\n\n\n}\n.description-content{\n    margin: 0px 20px;\n}\n\n.description-content p{\n    font-family: 'Poppins',sans-serif;\n    font-size: 13px;\n    /* color:#666666; */\n    text-align: left;\n    letter-spacing: 1px;\n}\n\n.reviews-content{\n    display: flex;\n    flex-direction: row;\n    margin-top:10px;\n}\n\n.reviews-content p{\n    margin-left: 20px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 13px;\n    text-align: left;\n    letter-spacing: 1px;\n\n}\n\n.reviews-card{\n    width:400px;\n    height:150px;\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    align-items: center;\n    justify-items: left;\n}\n\n.review-image{\n    width:30%;\n}\n\n.review-image img{\n    width:60px;\n    height:60px;\n    border-radius: 30px;\n    margin: 0px;\n\n}\n\n.review-stars{\n    margin-left: 0px;\n    \n}\n.review-stars {\n    outline: none;\n}\n\n.review-stars:focus {\n    outline: none;\n}\n\n.review-stars {\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.review-stars:hover,\n.review-stars:active {\n    border: none;\n    box-shadow: none;\n}\n\n\n.review-content{\n    width:70%;\n    display: flex;\n    flex-direction: column;\n    justify-content: left;\n    align-items:flex-start;\n    \n\n    \n}\n.review-content p{\n    font-size: 12px;\n    font-family: 'Poppins',sans-serif;\n    text-align:left;\n    line-height: 14px;\n    margin-bottom: 5px;\n    letter-spacing: 1px;\n    margin-left: 0px;\n    width:100%;\n    display: flex;\n    justify-content: left;\n}\n\n.mobile-navigation-buttons{\n    display: none;\n}\n\n\n@media screen and (max-width:768px){\n    .product-container {\n            margin: 110px 20px;\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            align-items: center;\n            margin-top:100px;\n    \n        }\n        .product-image {\n            width: 90%;\n            height: auto;\n    \n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-top: 0px;\n            ;\n        }\n        .product-image img{\n            width:90%;\n            height:auto;\n        }\n        .mobile-navigation-buttons {\n            display: flex;\n            flex-direction: row;\n            align-items: flex-start;\n            margin-top: 80px;\n        }\n    \n        .mobile-navigation-buttons button {\n            width: 30px;\n            height: 30px;\n            border-radius: 25px;\n            border: rgba(0, 0, 0, 0.3);\n            border-style: solid;\n            border-width: 1px;\n            margin-left: 10px;\n        }\n        .navigation-buttons{\n            display: none;\n        }\n        .product-details-container {\n            margin: 20px;\n            width: 90%;\n    \n        }\n    \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
